module.exports = __webpack_public_path__ + "media/images/projects/11-header-943fd9e3439d9dcdf2189e04bc3fcb60.jpg";